// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdClose } from 'react-icons/lib/md';
import * as selectors from '../../reducers';
import PopupHeader from '../PopupHeader';
import PopupHeaderRightGroup from '../PopupHeaderRightGroup';
import PopupContent from '../PopupContent';
import PopupContainer from '../PopupContainer';
import PopupHeaderTitle from '../PopupHeaderTitle';
import Button from '../Button';
import PopupCloseButton from '../PopupCloseButton';
import styles from './confirmMonitorChangeRoutePopup.css';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
import PopupFooter from '../PopupFooter';
import type { MONITOR_TYPE } from '../../types/monitors';
import type { ROUTE_TYPE } from '../../types/routes';
import { Cancel } from '../CommonTexts';


type ConfirmMonitorChangeRoutePopupPropTypes = {
  okAction: Function,
  route: ROUTE_TYPE,
  monitor: MONITOR_TYPE,
  isDeleting: boolean,
};

const ConfirmMonitorChangeRoutePopup = (
  {
    okAction,
    route,
    monitor,
    isDeleting,
  }: ConfirmMonitorChangeRoutePopupPropTypes,
) => (
  <PopupContainer>
    <PopupHeader>
      <PopupHeaderLeftGroup>
        <PopupHeaderTitle title="Cambiar Monitor" />
      </PopupHeaderLeftGroup>
      <PopupHeaderRightGroup>
        <PopupCloseButton
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </PopupHeaderRightGroup>
    </PopupHeader>
    <PopupContent clearPaddings>
      <div className={styles.deleteRouteContent}>
        <h2 className={styles.subtitle}>
          Ya existe un monitor asignado a la ruta:
          <span className={styles.name}>{ ` ${route.name}` }</span>
        </h2>
        <h1 className={styles.title}>
          Deseas reemplazar a
          <span className={styles.highlight}>{ ` ${route.monitor.first_name} ${route.monitor.last_name} ` }</span>
          por:
          <span className={styles.highlight}>{ ` ${monitor.first_name} ${monitor.last_name}` }</span>
          ?
        </h1>
        <br />

      </div>
    </PopupContent>
    <PopupFooter align="center">
      <PopupCloseButton title={Cancel()} tint="paleGray" />
      <Button
        onClick={() => {
          if (okAction && monitor && route) {
            okAction(monitor.id, parseInt(route.id, 10));
          }
        }}
        isLoading={isDeleting}
        tint="primary"
        title="Cambiar Monitor"
      />
    </PopupFooter>
  </PopupContainer>
);

export default connect(
  state => ({
    isDeleting: selectors.isFetchingRoutes(state),
  }),
  undefined,
)(ConfirmMonitorChangeRoutePopup);



// WEBPACK FOOTER //
// ./src/scripts/components/ConfirmMonitorChangeRoutePopup/index.jsx